import "./quiz.css";
import React, { useState } from "react";

import { Typography, Card, Button, Icon, Progress } from "antd";

import { questions } from "./questions";
import { ResultDesc } from "./ResultDesc";

const { Title, Paragraph } = Typography;

const Quiz = () => {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({});
  const [choice, setChoice] = useState(null);
  const [result, setResult] = useState(null);

  const { img, options } = questions[current];

  const total = questions.length - 1;
  const progress = result ? 100 : Math.ceil((current / (total + 1)) * 100);

  const handleNext = () => {
    if (current >= total) {
      return handleResult();
    }

    const { types } = options[choice];

    const update = { ...answers };

    for (let type of types) {
      if (update[type]) {
        update[type] += 1;
      } else {
        update[type] = 1;
      }
    }

    setChoice(null);
    setAnswers(update);
    setCurrent(current + 1);
    console.log("Answers", { types, update });
  };

  const handleResult = () => {
    const winner = Object.entries(answers).reduce(
      (winner, [type, n]) => (answers[winner] > n ? winner : type),
      "N"
    );

    console.log("Winner", winner);
    setResult(winner);
  };

  const handleRetake = () => {
    setCurrent(0);
    setAnswers({});
    setChoice(null);
    setResult(null);
    console.log("retake", { current, answers, choice, result });
  };

  return (
    <Card
      cover={
        <>
          <Progress className="progress" percent={progress} />

          {result && <ResultDesc onRetake={handleRetake} type={result} />}

          {!result && (
            <img alt="example" className="quiz__img" src={`/${img}`} />
          )}
        </>
      }
    >
      {!result && (
        <>
          <Card>
            {options.map((option, index) => (
              <Card.Grid
                key={option.value}
                hoverable={choice !== index}
                onClick={() => setChoice(index)}
                className={`quiz__option ${choice === index ? "active" : ""}`}
              >
                {option.value}
              </Card.Grid>
            ))}
          </Card>

          <div className="actions">
            <Button
              type="primary"
              onClick={handleNext}
              disabled={choice === null}
            >
              Próximo
              <Icon type="arrow-right" />
            </Button>
          </div>
        </>
      )}
    </Card>
  );
};

const QuizInfo = () => {
  return (
    <Card>
      <Paragraph>
        Daltonismo é uma deficiência que afeta as células do olho e torna
        difícil a identificação de cores como vermelho, verde, azul ou até mesmo
        todas as cores.
      </Paragraph>
      <Paragraph>
        O teste de Ishihara permite verificar o daltonismo ao exibir números sob
        um fundo com cores de difícil distinção para quem porta a deficiência.
      </Paragraph>
    </Card>
  );
};

export const QuizScreen = () => {
  const [start, setStart] = useState(false);

  return (
    <div className="quiz">
      <Card>
        <Title level={2}>Teste de Daltonismo</Title>
        {start && <Quiz />}
        {!start && <QuizInfo />}
        {!start && (
          <div className="actions">
            <Button type="primary" onClick={() => setStart(true)}>
              Começar
              <Icon type="form" />
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};
